import PropTypes            from 'prop-types';
import React                from 'react';
import { getKosSummary }    from '../../../dmpconnect/constants/ohif';
import Alert                from '../../Common/Message/Alert'

const KosDocument = ({ dicomKos, ohifConfig, content }) => {
  const
    {
      GeneralStudy     : {
        s_description: studyName = '',
      } = {},
      SrDocumentContent: {
        s_textValue: kosSummary = ''
      } = {},
    } = dicomKos;
  
  let summary;
  if (!kosSummary) {
    summary = getKosSummary(dicomKos);
  } else {
    summary = kosSummary;
  }
  
  return <>
    <Alert type="warning">
      <p>La visualisation de ce type de document n&apos;est pas possible directement dans l'application.</p>
      {(summary || studyName) && <p className="mb-0">Nous affichons ici le résumé du document.</p>}
    </Alert>
    {(summary || studyName) && (
      <>
        <div className="documentPage txt mb-3">
          {summary || studyName}
        </div>
      </>
    )}
    
    {/* <div className="documentPage txt">{b64DecodeUnicode(content)}</div> */}
  </>;
};

KosDocument.propTypes = {
  dicomKos  : PropTypes.object.isRequired,
  ohifConfig: PropTypes.object.isRequired,
  content   : PropTypes.string.isRequired,
};

export default KosDocument;
